import React from 'react'
import { GrabbedTitle, CountdownTimerWrapper, GrabbedWrapper, TitleWrap } from './BountyContent/BountyContent.styled'
import { useBounties } from '@src/context/BountiesContext'
import CountdownTimer from '@src/components/Elements/CountdownTimer'

const AlreadyGrabbedOverlay = ({ disabled }: { disabled: boolean }) => {
  const { getClaimedBountyWithFutureExpiration } = useBounties()
  const claimedBounty = getClaimedBountyWithFutureExpiration()

  if (disabled) return null

  return (
    <GrabbedWrapper className="grabbed-wrapper">
      <TitleWrap>
        <GrabbedTitle>YOU CAN CLAIM THIS BOUNTY AFTER THE PREVIOUS BONUS IS UNLOCKED</GrabbedTitle>
        <CountdownTimerWrapper>
          <CountdownTimer expiresAt={claimedBounty?.expires || null} />
        </CountdownTimerWrapper>
      </TitleWrap>
    </GrabbedWrapper>
  )
}

export default React.memo(AlreadyGrabbedOverlay)
